window.switchLang = function(url) {
    //console.log("Switching language to:", url); // Existing log

    $.ajax({
        type: 'GET',
        url: url,
        success: function (response) {
            // console.log("Language switch successful!"); // Existing log
            // console.log("Received previous URL:", response); // Log the received previous URL

            if (response.previousUrl) {
                // Create a URL object based on the previous URL
                const previousUrl = new URL(response.previousUrl);
                
                // Set or update the lang parameter
                if (response.lang) {
                    previousUrl.searchParams.set('lang', response.lang); // Append the lang parameter
                }

                // Log the modified previous URL for debugging
                //console.log("Redirecting to previousUrl with lang parameter:", previousUrl.toString());

                // Redirect to the updated previous URL
                location.href = previousUrl.toString();
            } else {
                // No previous URL found, handle the current URL
                //console.log("No previousUrl found. Adding lang to the current URL.");

                // Create a URL object based on the current location
                const currentUrl = new URL(window.location.href);
                
                // Set or update the lang parameter
                if (response.lang) {
                    currentUrl.searchParams.set('lang', response.lang); // e.g., 'en' or 'de'
                }

                // Log the modified URL for debugging
                //console.log("Redirecting to updated URL with lang:", currentUrl.toString());

                // Redirect to the updated URL with the lang parame
                location.href = currentUrl.toString();
            }
        },
        error: function (response) {
            console.error("Error switching language:", response); // Existing log
            reloadPageAfterSwitchingLanguage(response); // Consider removing this if unnecessary
        }
    });
}

window.reloadPageAfterSwitchingLanguage = function(response) {
    //console.log("Reloading page after language switch");

    let previousUrl = response.previousUrl; // Access from AJAX response
    if (previousUrl) {
        location.href = previousUrl;
    } else {
        // Handle case where no previous URL is available (e.g., reload)
        location.reload();
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/language_switcher.js